export const sites = [
  {
    path: '/sites',
    name: 'Sites',
    component: () => import('./index.vue'),
    meta: {
      rule: 'SITES',
      authRequired: true,
      title: 'general.sites',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.sites',
          disabled: true,
          href: '#/sites'
        }
      ]
    }
  },
  {
    path: '/sites/add',
    name: 'addSites',
    component: () => import('./form.vue'),
    meta: {
      rule: 'SITE_CREATE',
      authRequired: true,
      title: 'sites.add',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.sites',
          disabled: false,
          href: '#/sites'
        },
        {
          text: 'sites.add',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/sites/edit/:id',
    name: 'editSites',
    component: () => import('./form.vue'),
    meta: {
      rule: 'SITE_UPDATE',
      authRequired: true,
      title: 'sites.edit',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.sites',
          disabled: false,
          href: '#/sites'
        },
        {
          text: 'sites.edit',
          disabled: true
        }
      ]
    }
  }
]